import { useQuery } from "@tanstack/react-query";
import apiRoutes from "../apiRoutes"
import api from "../utils"

export const useWalletAddresses = () => {
    const getWalletAddress = async () => {
        const res = await api.get(apiRoutes.walletAddresses);
        return res.data
    }
    const { data: addresses, ...rest } = useQuery<WalletAddressData>({
        queryKey: ["wallet_addresses"],
        queryFn: getWalletAddress
    })
    return {
        addresses,
        ...rest
    }
}